
import React from 'react';
import { Button } from '@/components/ui/button';
import { Filter } from 'lucide-react';

interface FilterButtonProps {
  hasActiveFilters: boolean;
  onClick: () => void;
}

const FilterButton: React.FC<FilterButtonProps> = ({ hasActiveFilters, onClick }) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="text-neutral-600 hover:text-neutral-900 hover:bg-neutral-100/60 relative min-h-[44px] px-3 py-2 text-sm border border-neutral-200/60"
      title="Filter candidates"
    >
      <Filter className="h-4 w-4 mr-1.5" />
      Filters
      {hasActiveFilters && (
        <div className="absolute -top-1 -right-1 h-2 w-2 bg-neutral-900 rounded-full" />
      )}
    </Button>
  );
};

export default FilterButton;
